module.exports = __webpack_public_path__ + "media/14.f8673963.mp3";